import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Wooden flower planter box with soil and a few blooms.
const build: (ctx: DecoBuildCtx) => void = ({ box, cone, seed }) => {
  const wood = shade(0x7a5c3a, (rand(seed) - 0.5) * 0.1);
  const soil = shade(0x3d2a18, (rand(seed + 1) - 0.5) * 0.08);
  const blooms = [0xd45a6a, 0xe8c86a, 0x7a9a4a, 0x8a6ab0];
  box(0, 0.22, 0, 1.1, 0.44, 0.55, wood);
  box(0, 0.42, 0, 0.95, 0.08, 0.42, soil);
  for (let i = 0; i < 4; i++) {
    const x = -0.3 + i * 0.2;
    const z = (i % 2 === 0 ? -0.08 : 0.08);
    const c = blooms[(i + Math.floor(rand(seed + i) * 3)) % blooms.length]!;
    box(x, 0.55, z, 0.03, 0.22, 0.03, 0x3a6a2a);
    cone(x, 0.68, z, 0.1, 0.12, shade(c, (rand(seed + 10 + i) - 0.5) * 0.1));
  }
};

export default build;
